import { JsFormResponseHandlerObject } from '../jsFormTypes';
import { JRpcResponse, JsonRpcResponseFactory } from '../jsonRpc/jsonRpcResponseFactory';
import { ErrorToolTip, TooltipDirection } from '../../newErrorToolTip';
import { Localization } from '../../../localization/localization';
import { JRpcErrResponse } from '../jsonRpc/jRpcErrResponse';
import { JRpcSuccResponse } from '../jsonRpc/jRpcSuccResponse';
import { CurrentUser } from '../user/currentUser';
import { configureHttpAuth } from '../../../startup/configureHttpAuth';
import { GtmSender } from '../../../marketing/GtmSender';
import { SystemEvents } from '../../../constants/gameEvents';
import { disableJsFormHandler } from '../jsForm';
import { StretchPopup } from '../../../popups/stretchPopup';
import { AuthStepConversionSend } from '../../../marketing/auth-step-conversion-send';
import { ConsentSources } from '../../../constants/ConsentSources';

window.app.config.landings.dontoutPopupEnabled = false;
window.app.registrationV3Step2WithSubscription = registrationV3Step2WithSubscription;
window.app.registrationV3Step3WithSubscription = registrationV3Step3WithSubscription;
window.app.changeRegWithSubscriptionButtonState = changeRegWithSubscriptionButtonState;

function getMain(caller: HTMLElement | JQuery<HTMLElement>) {
    const result = $(caller).closest('.js-main');
    const id = $(result).attr('id');
    return $(`#${id}`);
}

let errorToolTip: ErrorToolTip;

$(function initRegistrationV3WithSubscriptionForm() {
    errorToolTip = ErrorToolTip.getTooltipElement();

    $('.js-close-button-reg').on('click', function handleV3CloseButtonClick() {
        const main = getMain(this);
        main.removeClass('step1 step2');
        main.addClass('step1');
        StretchPopup.stretch();
    });

    $('.js-form .button-back').on('click', function handleV3BackButtonClick() {
        const main = getMain(this);
        main.removeClass('step1 step2');
        main.addClass('step1');
        StretchPopup.stretch();
    });
});


function registrationV3Step2WithSubscription(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const passwordInput = $('input[name=password]', data.form);
    const passwordInputContainer = passwordInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const passwordValue = passwordInput.val().toString();
    if (!passwordValue.trim()) {
        passwordInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            passwordInput,
            toolTipDirectionSide as TooltipDirection,
            // @ts-ignore
            // eslint-disable-next-line no-nested-ternary,@typescript-eslint/no-magic-numbers
            !passwordInput.val() ? Localization._n('pass_empty') : passwordInput.val().length < 6
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                ? Localization._n('pass_short') : passwordInput.val().length > 20
                    ? Localization._n('pass_long')
                    : Localization._n('common_error')
        );
        return;
    }

    const authStepConversionSender = new AuthStepConversionSend(window.location);
    authStepConversionSender.send('3');

    const main = getMain(data.caller);
    main.removeClass('step1 step2');
    main.addClass('step3');
    data.caller.removeAttr('disabled');
    $("span[data-action='openSingle']").parent()
        .hide();
}

async function registrationV3Step3WithSubscription(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const form = data.form;
    const email = $('input[name=email]', form).val() as string;
    const response = (new JsonRpcResponseFactory<{
        huid: number,
        suid: string,
        token: string
    }>()).getJsonRpcResponseFromObject(data.response);

    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const passwordInput = $('input[name=password]', data.form);
    const passwordInputContainer = passwordInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    if (response instanceof JRpcErrResponse) {
        const main = getMain(data.caller);
        main.removeClass('step1 step3');
        main.addClass('step2');
        passwordInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            passwordInput,
            toolTipDirectionSide as TooltipDirection,
            response.error.message
        );
        return;
    }

    if (response instanceof JRpcSuccResponse) {
        window.app.config.suid = response.result.suid.toString();
        window.app.user_huid = response.result.huid;
        window.app.config.user_auth_token = response.result.token;

        if ($(data.caller).data('subscription') !== false) {
            const currentUser = CurrentUser.getInstance();
            const isChanged = await currentUser.setConsentState(email, true, ConsentSources.LP);
            if (!isChanged) {
                console.error(`Can't set consent for user with suid ${currentUser.getSuid()}`);
            }
        }

        configureHttpAuth();
        GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);
        disableJsFormHandler(data.form);

        location.reload();
        return;
    }

    passwordInputContainer.addClass('error');
    errorToolTip.showTooltipElement(
        passwordInput,
        toolTipDirectionSide as TooltipDirection,
        Localization._n('common_error')
    );
}

function changeRegWithSubscriptionButtonState(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const form = data.form;
    const termsCheckbox = $('.js-subscription_agree', form);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];

    if (termsCheckbox.length && !termsCheckbox.hasClass('checked')) {
        errorToolTip.showTooltipElement(
            termsCheckbox,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('agree_error'),
            true
        );
        return false;
    }
    return true;
}
